import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=7a6223cc&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a6223cc')) {
      api.createRecord('7a6223cc', component.options)
    } else {
      api.reload('7a6223cc', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=7a6223cc&", function () {
      api.rerender('7a6223cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2rzNufY87sO7B/JS/comp/pricelist.vue"
export default component.exports